import {useEffect} from 'react'
import {useCustomerId, useCustomerBaskets} from '@salesforce/commerce-sdk-react'
import {buildPriceTestParam} from '@/helpers/sfccHelpers'

/**
 * This hook combine some commerce-react-sdk hooks to provide more derived data for Retail App baskets
 * @param id - basket id to get the current used basket among baskets returned, use first basket in the array if not defined
 * @param shouldFetchProductDetail - boolean to indicate if the baskets should fetch product details based on basket items
 */
export const useCurrentBasket = ({enabled = true, id = ''} = {}) => {
    const customerId = useCustomerId()
    const {
        data: basketsData,
        isLoading: basketsDataIsLoading,
        refetch: basketsDataRefetch,
        ...restOfQuery
    } = useCustomerBaskets(
        {
            parameters: {
                customerId,
                ...buildPriceTestParam()
            }
        },
        {
            enabled: !!customerId && enabled,
            staleTime: 1000 * 60 * 1 // 1 minute
        }
    )

    useEffect(() => {
        if (basketsData?.baskets?.length === 0 && !basketsDataIsLoading) {
            console.warn('No baskets found for the current customer.')
        }
    }, [basketsData, basketsDataIsLoading])

    const currentBasket =
        !basketsDataIsLoading && !!id
            ? basketsData?.baskets?.find((basket) => basket?.basketId === id)
            : basketsData?.baskets?.[0]

    return {
        ...restOfQuery,
        isLoading: basketsDataIsLoading,
        data: currentBasket,
        derivedData: {
            hasBasket: (basketsData?.total ?? 0) > 0,
            totalItems:
                currentBasket?.productItems?.reduce((acc, item) => acc + (item.quantity || 0), 0) ||
                0
        },
        refetchBaskets: basketsDataRefetch
    }
}
